export default __webpack_public_path__ + "static/N0159-cf4ad923bf62ab2785eb60015d159d25.png";